module.exports = __webpack_public_path__ + "static/img/osticket_logo.b4f3605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/osticket_logo.png
// module id = 4sBf
// module chunks = 1